module.exports = __webpack_public_path__ + "img/example-02.5dceb842.jpg";